export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_REQUEST_IMPERSONATE = 'AUTH_REQUEST_IMPERSONATE';
export const AUTH_SUCCESS_IMPERSONATE = 'AUTH_SUCCESS_IMPERSONATE';
export const AUTH_EXACHANGEUSER = 'AUTH_EXACHANGEUSER';
export const AUTH_ADMINUSER = 'AUTH_ADMINUSER';
export const SET_ROLE = 'SET_ROLE';
export const AUTH_REQUEST_TWOFACTOR = 'AUTH_REQUEST_TWOFACTOR';
export const AUTH_SUCCESS_TWOFACTOR = 'AUTH_SUCCESS_TWOFACTOR';
export const AUTH_SUCCESS_TWOFACTOR_UPDATE = 'AUTH_SUCCESS_TWOFACTOR_UPDATE';